import { useEffect, useState, useCallback } from 'react'
import { withRouter } from '../utils'
import axios from 'axios'

function MyAccount({ navigate }) {
  const apiHost = process.env.REACT_APP_APIHOST || 'http://localhost:3033'
  const [user, setUser] = useState(null)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [company, setCompany] = useState('')
  const [title, setTitle] = useState('')
  const [phoneNo, setPhoneNo] = useState('')
  const [currentPw, setCurrentPw] = useState('')
  const [newPw, setNewPw] = useState('')
  const [confirmPw, setConfirmPw] = useState('')
  const [toast, setToast] = useState(null)
  const notify = useCallback((msg, type) => { setToast({ msg, type }); setTimeout(() => setToast(null), 3500) }, [])
  const [daysLeft, setDaysLeft] = useState(null)
  const [showUpgrade, setShowUpgrade] = useState(false)
  const [upgradeForm, setUpgradeForm] = useState({ countries: '', seats: '1', message: '' })
  const [upgradeSent, setUpgradeSent] = useState(false)
  const [upgradeSending, setUpgradeSending] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) { navigate('/login'); return }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      axios.get(apiHost + '/users/' + payload.id).then(res => {
        if (res.data.status) {
          const u = res.data.data
          setUser(u); setFirstName(u.firstName); setLastName(u.lastName)
          setCompany(u.company || ''); setTitle(u.title || ''); setPhoneNo(u.phoneNo || '')
          if (u.accessExpiresAt) {
            const dl = Math.max(0, Math.ceil((new Date(u.accessExpiresAt) - new Date()) / (24*60*60*1000)))
            setDaysLeft(dl)
          }
        }
      })
    } catch(e) { navigate('/login') }
  }, [apiHost, navigate])

  const submitUpgrade = async () => {
    if (!upgradeForm.countries) { notify('Please specify countries.', 'warn'); return }
    setUpgradeSending(true)
    try {
      await axios.post(apiHost + '/contact/access-request', {
        firstName, lastName, email: user.email, company, title,
        phone: phoneNo,
        message: `UPGRADE REQUEST\nCountries: ${upgradeForm.countries}\nNumber of seats: ${upgradeForm.seats}\nCurrent expiry: ${user.accessExpiresAt ? new Date(user.accessExpiresAt).toLocaleDateString() : 'N/A'}\nDays left: ${daysLeft}\n\nAdditional notes: ${upgradeForm.message}`
      })
      setUpgradeSent(true)
      notify('Request sent! We will get back to you shortly.', 'ok')
    } catch(e) { notify('Failed to send.', 'err') }
    setUpgradeSending(false)
  }

  const saveProfile = async () => {
    try {
      await axios.put(apiHost + '/users/' + user._id, { firstName, lastName, company, title, phoneNo })
      notify('Profile updated.', 'ok')
    } catch(e) { notify('Failed to update.', 'err') }
  }

  const changePassword = async () => {
    if (!currentPw || !newPw) return notify('Fill all password fields.', 'warn')
    if (newPw !== confirmPw) return notify('Passwords do not match.', 'warn')
    if (newPw.length < 6) return notify('Min 6 characters.', 'warn')
    try {
      await axios.put(apiHost + '/users/' + user._id, { password: newPw })
      notify('Password changed.', 'ok')
      setCurrentPw(''); setNewPw(''); setConfirmPw('')
    } catch(e) { notify('Failed.', 'err') }
  }

  if (!user) return null

  const s = { background:'#141414',color:'#e6e6e6',minHeight:'100vh',fontFamily:'Inter,sans-serif' }
  const card = { background:'#1a1a1a',border:'1px solid rgba(255,255,255,0.06)',borderRadius:4,padding:'24px 28px',marginBottom:16 }
  const inp = { width:'100%',background:'#111',border:'1px solid rgba(255,255,255,0.1)',borderRadius:3,padding:'10px 14px',color:'#e6e6e6',fontSize:13,outline:'none',boxSizing:'border-box' }
  const lbl = { fontSize:10,color:'#888',textTransform:'uppercase',letterSpacing:1,marginBottom:4,display:'block' }
  const btn = { background:'#C29717',color:'#fff',border:'none',borderRadius:3,padding:'10px 24px',fontSize:12,fontWeight:600,cursor:'pointer',letterSpacing:0.5 }
  const row = { display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12 }

  return (
    <div style={s}>
      {/* Header */}
      <div style={{ padding:'16px 24px',borderBottom:'1px solid rgba(255,255,255,0.06)',display:'flex',justifyContent:'space-between',alignItems:'center' }}>
        <img src="/icons/logo.webp" alt="FORTE" style={{ height:16,opacity:0.85 }} />
        <svg onClick={() => navigate(-1)} style={{ cursor:'pointer',opacity:0.5 }} width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </div>

      <div style={{ maxWidth:600,margin:'0 auto',padding:'40px 20px' }}>
        <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:24 }}>
          <div>
            <div style={{ fontSize:9,color:'#C29717',textTransform:'uppercase',letterSpacing:2 }}>My Account</div>
            <div style={{ fontSize:20,fontWeight:500 }}>{firstName} {lastName}</div>
            <div style={{ fontSize:11,color:'#888' }}>{company}{title ? ' — ' + title : ''}</div>
          </div>
          <div style={{ display:'flex',gap:8 }}>
            <span onClick={() => navigate('/invite-team')} style={{ fontSize:11,color:'#C29717',cursor:'pointer',border:'1px solid rgba(194,151,23,0.3)',borderRadius:3,padding:'6px 14px' }}>Invite team</span>
            <span onClick={() => navigate('/cockpit')} style={{ fontSize:11,color:'#888',cursor:'pointer',border:'1px solid rgba(255,255,255,0.1)',borderRadius:3,padding:'6px 14px' }}>Back</span>
          </div>
        </div>

        {daysLeft !== null && (
          <div style={{ ...card, borderLeft: '3px solid ' + (daysLeft <= 7 ? '#e55' : daysLeft <= 14 ? '#e88a2a' : '#C29717') }}>
            <div style={{ display:'flex',justifyContent:'space-between',alignItems:'flex-start',flexWrap:'wrap',gap:12 }}>
              <div>
                <div style={{ fontSize:24,fontWeight:600,color: daysLeft <= 7 ? '#e55' : daysLeft <= 14 ? '#e88a2a' : '#C29717' }}>{daysLeft} day{daysLeft !== 1 ? 's' : ''} left</div>
                <div style={{ fontSize:12,color:'#888',marginTop:4,lineHeight:1.6 }}>
                  Your trial access expires on {user.accessExpiresAt ? new Date(user.accessExpiresAt).toLocaleDateString('en-US', {day:'numeric',month:'long',year:'numeric'}) : '—'}.<br/>
                  To get <b style={{color:'#ccc'}}>permanent and full access</b> including personnel-level alerting, contact us or fill the form below.
                </div>
                <div style={{ marginTop:8,fontSize:11 }}>
                  <a href="mailto:business@forteintel.com" style={{ color:'#C29717',textDecoration:'none' }}>business@forteintel.com</a>
                  <span style={{ color:'#333',margin:'0 8px' }}>|</span>
                  <span onClick={() => setShowUpgrade(!showUpgrade)} style={{ color:'#C29717',cursor:'pointer',textDecoration:'underline' }}>{showUpgrade ? 'Hide form' : 'Request full access'}</span>
                </div>
              </div>
            </div>

            {showUpgrade && !upgradeSent && (
              <div style={{ marginTop:16,paddingTop:16,borderTop:'1px solid rgba(255,255,255,0.06)' }}>
                <div style={{ fontSize:11,fontWeight:600,color:'#ccc',marginBottom:12 }}>Request full access</div>
                <div style={{ marginBottom:10 }}>
                  <label style={lbl}>Countries of interest *</label>
                  <input style={inp} placeholder="e.g. Saudi Arabia, UAE, Qatar, Iraq, Lebanon..." value={upgradeForm.countries} onChange={e => setUpgradeForm({...upgradeForm, countries: e.target.value})} />
                </div>
                <div style={row}>
                  <div>
                    <label style={lbl}>Number of seats needed</label>
                    <input style={inp} type="number" min="1" value={upgradeForm.seats} onChange={e => setUpgradeForm({...upgradeForm, seats: e.target.value})} />
                  </div>
                  <div>
                    <label style={lbl}>Additional notes</label>
                    <input style={inp} placeholder="Optional" value={upgradeForm.message} onChange={e => setUpgradeForm({...upgradeForm, message: e.target.value})} />
                  </div>
                </div>
                <button style={btn} onClick={submitUpgrade} disabled={upgradeSending}>{upgradeSending ? 'Sending...' : 'Submit request'}</button>
              </div>
            )}
            {upgradeSent && (
              <div style={{ marginTop:12,fontSize:12,color:'#4CAF50' }}>Request sent — our team will contact you shortly.</div>
            )}
          </div>
        )}

        <div style={card}>
          <div style={{ fontSize:12,fontWeight:600,marginBottom:16,color:'#ccc' }}>Profile</div>
          <div style={row}>
            <div><label style={lbl}>First name</label><input style={inp} value={firstName} onChange={e => setFirstName(e.target.value)} /></div>
            <div><label style={lbl}>Last name</label><input style={inp} value={lastName} onChange={e => setLastName(e.target.value)} /></div>
          </div>
          <div style={row}>
            <div><label style={lbl}>Company</label><input style={inp} value={company} onChange={e => setCompany(e.target.value)} /></div>
            <div><label style={lbl}>Title</label><input style={inp} value={title} onChange={e => setTitle(e.target.value)} /></div>
          </div>
          <div style={{ marginBottom:12 }}>
            <label style={lbl}>Phone</label><input style={inp} value={phoneNo} onChange={e => setPhoneNo(e.target.value)} />
          </div>
          <div style={{ marginBottom:12 }}>
            <label style={lbl}>Email</label><input style={{...inp,opacity:0.5}} value={user.email} disabled />
          </div>
          <button style={btn} onClick={saveProfile}>Save changes</button>
        </div>

        <div style={card}>
          <div style={{ fontSize:12,fontWeight:600,marginBottom:16,color:'#ccc' }}>Change password</div>
          <div style={{ marginBottom:12 }}><label style={lbl}>Current password</label><input style={inp} type="password" value={currentPw} onChange={e => setCurrentPw(e.target.value)} /></div>
          <div style={row}>
            <div><label style={lbl}>New password</label><input style={inp} type="password" value={newPw} onChange={e => setNewPw(e.target.value)} /></div>
            <div><label style={lbl}>Confirm</label><input style={inp} type="password" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} /></div>
          </div>
          <button style={btn} onClick={changePassword}>Change password</button>
        </div>
      </div>

      {toast && (
        <div style={{ position:'fixed',bottom:24,left:'50%',transform:'translateX(-50%)',background:'#1a1a1a',border:'1px solid ' + (toast.type==='ok'?'rgba(76,175,80,0.3)':toast.type==='err'?'rgba(229,85,85,0.3)':'rgba(194,151,23,0.3)'),borderRadius:4,padding:'12px 24px',fontSize:13,color:toast.type==='ok'?'#4CAF50':toast.type==='err'?'#e55':'#C29717',zIndex:99999,boxShadow:'0 8px 24px rgba(0,0,0,0.5)' }}>{toast.msg}</div>
      )}
    </div>
  )
}
export default withRouter(MyAccount)
